module.exports = __webpack_public_path__ + "img/72_10.38645672.png";